module.exports = __webpack_public_path__ + "static/media/NavLogo.aa149438.svg";